(function () {

  'use strict';

  /**
   * Define the constants application module
   */

  angular
    .module('constants',[])
    .constant('ServerData', {
      // PROD URL
      URL: 'http://api.hub-buildings.com',
      PORT: '80',
      FILES_URL: 'https://www.hub-buildings.com',
      ENV: 'hps',

      // DEV URL
      // URL: 'http://178.62.118.66',
      // FILES_URL: 'https://www.hub-buildings.com',
      // PORT: '5000',
      // ENV: 'hds'

    })
    .constant('Months', ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'SEP', 'OCT', 'DIC']);

}());